// extracted by mini-css-extract-plugin
export default {"details__topBarContainer":"PackageHistoryView_details__topBarContainer__yJ-b1"};